import { inject, Provider } from '@angular/core';
import { TASK_COMPLETION_REFUSAL_HANDLER, TaskCompletionRefusalHandler } from './surface/detail/task.completion.refusal.handler';
import { WebTaskCompletionRefusalFlow } from './task.completion.refusal.web.flow';

/** The Web App: a refused completion opens its dialog, and a holder of the right may complete past missing evidence. */
export const webTaskCompletionRefusalProvider: Provider = {
  provide: TASK_COMPLETION_REFUSAL_HANDLER,
  useFactory: (): TaskCompletionRefusalHandler => {

    const flow = inject(WebTaskCompletionRefusalFlow);

    return (error, resendWithOverride) => flow.handle(error, resendWithOverride);
  },
};
